<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">{{$t("You've successfully topped up your balance. Your balance will be updated in a moment. In case of any questions, please contact us at {email}", {email: `support@${$parent.hostname}`})}}</div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  name: 'PaymentSuccessPage',
  props: [],
  components: {
  },
  data: function() {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>